'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _directionalstyles = require('../utils/directionalstyles');

var _directionalstyles2 = _interopRequireDefault(_directionalstyles);

var _colors = require('../utils/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (rtl, fontFamily) {
    var nameFontSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 16;

    var _styles = {
        name: {
            fontFamily: fontFamily,
            fontSize: nameFontSize,
            paddingBottom: 19
        },

        contactDetail: {
            fontSize: 14,
            lineHeight: '18px',
            paddingBottom: 18,
            fontFamily: fontFamily
        },

        contactDetailLast: {
            paddingBottom: 0
        },

        icon: {
            verticalAlign: 'baseline',
            paddingInlineEnd: 12
        },

        linkStyle: {
            color: _colors2.default.B10
        }
    };

    return (0, _directionalstyles2.default)(_styles, rtl);
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wix-restaurants-renderer-js/dist/Reservations/ContactMapDetails.style.js
// module id = 1151
// module chunks = 0